import { Button } from '@flowus/common/components/button';
import { useOnceAnyDay } from '@flowus/common/hooks/use-once-any-day';
import { useOpenModal } from '@flowus/common/next-modal';
import type { PlanCouponDto } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useCallback } from 'react';
import { request } from 'src/common/request';
import { getCurrentSpaceId } from 'src/hooks/space/get-space';
import { Modals } from 'src/modals';
import { setSpaceCountDown } from 'src/services/app-support/local-state';
import { OpenSettingFrom } from 'src/views/main/setting-modal/type';
import { useOpenUpgradeSpace } from 'src/views/main/setting-modal/use-open-setting-modal';
import { CouponList } from '../select-upgrade-plan/common';

interface Props {
  list?: PlanCouponDto[];
}
const SalesModal: FC<Props> = (props) => {
  const openModal = useOpenModal();
  const openUpgradeSpace = useOpenUpgradeSpace();
  const { list = [] } = props;

  return (
    <div className="next-modal flex flex-col px-7 pt-10 pb-5 w-96">
      <div className="text-center text-t1-medium mb-5">🧧 恭喜你！获得专属优惠</div>
      <CouponList couponList={list} />
      <Button
        className="mt-7"
        colorType="active"
        onClick={() => {
          openModal.closeModal(Modals.KOL_SALES);
          openUpgradeSpace(OpenSettingFrom.kol_sales);
        }}
      >
        立即使用
      </Button>
    </div>
  );
};

export const useOpenKolSalesModal = () => {
  const openModal = useOpenModal();
  const spaceId = getCurrentSpaceId();
  const key = `${Modals.KOL_SALES}-${spaceId}`;
  const { showOnce, close } = useOnceAnyDay(key, { endDay: -1 });

  return useCallback(async () => {
    if (!showOnce) {
      return false;
    }
    const res = await request.infra.exclusiveCouponPopup(getCurrentSpaceId(), false);
    if (res.list?.length) {
      setSpaceCountDown(spaceId, Date.now());
      close();
      openModal.modal({
        modalId: Modals.KOL_SALES,
        content: () => <SalesModal list={res.list} />,
      });
      return true;
    }
    return false;
  }, [close, openModal, showOnce, spaceId]);
};
